module.exports = __webpack_public_path__ + "static/visionar_augemented_reality_the_3_best_smart_glasses_in_2020-870eb9c7c281eb9a1ff1a6132f28d0ae.jpg";